import { Navigate, useLocation } from "react-router";

/**
 * The destination's old address, `/inquiries` and everything under it
 * (#140). Its job pages are written on every job already drafted into a
 * Company's rental system (#121) and in every New Inquiry email already
 * sent, and the list is what people bookmarked, so each goes to the same
 * place under `/enquiries` with its query intact rather than to Not
 * Found. `replace`, so Back from the page goes to wherever the reader
 * came from rather than back into this redirect.
 */
export function OldInquiriesPath() {
  const { pathname, search } = useLocation();
  return (
    <Navigate
      to={`${pathname.replace(/^\/inquiries/, "/enquiries")}${search}`}
      replace
    />
  );
}
